<style lang="less" scoped>

</style>

<template>
  <div class="registration">

  </div>
</template>

<script>
export default {
  data()
  {
    return {
    }
  },
  created()
  {
  },
  methods: {
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/login/Registration.vue